const resource = 'promos';

export default ($axios) => ({
	getPromos(params={}) {
		return $axios.get(`/${resource}`, { params });
	},
});
